export function isTransientNetworkError(error) {
  if (!error) return false;
  if (error.name === "AbortError") return true;

  const message = String(error.message || error);
  return (
    /failed to fetch/i.test(message) ||
    /load failed/i.test(message) ||
    /networkerror/i.test(message) ||
    /network request failed/i.test(message) ||
    /the internet connection appears to be offline/i.test(message)
  );
}
